import createApp from "./main";
import Worker from 'worker-loader!./web-worker'

const app = createApp(
  {
    litiumBaseUrl: process.env.LITIUM_URL,
  },
  () => new Worker()
);

app.mount("#app");